export const cardType = [
  // General types
  { text: 'Cash', value: 0 },
  { text: 'Check', value: 1 },
  { text: 'Coupon', value: 2 },
  { text: 'BankTransfer', value: 3 },
  { text: 'Mobile', value: 4 },

  // Credit card types
  { text: 'Visa', value: 10 },
  { text: 'MasterCard', value: 11 },
  { text: 'AmericanExpress', value: 12 },
  { text: 'Discover', value: 13 },
  { text: 'Amex', value: 14 },
  { text: 'BCGlobal', value: 15 },
  { text: 'CarteBlanch', value: 16 },
  { text: 'DinersClub', value: 17 },
  { text: 'InstaPaymentCard', value: 18 },
  { text: 'JCBCard', value: 19 },
  { text: 'KoreanLocal', value: 20 },
  { text: 'LaserCard', value: 21 },
  { text: 'Maestro', value: 22 },
  { text: 'Solo', value: 23 },
  { text: 'SwitchCard', value: 24 },
  { text: 'UnionPay', value: 25 },
  { text: 'WesterUnion', value: 26 },

  // Fallback types
  { text: 'NotFormatted', value: 98 },
  { text: 'Unknown', value: 99 },
]
